"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = System;

function System() {}

System.arraycopy = function (src, srcPos, dest, destPos, len) {
  var c = 0;

  for (var i = srcPos; i < srcPos + len; i++) {
    dest[destPos + c] = src[i];
    c++;
  }
};

System.getProperty = function (name) {
  return {
    'line.separator': '\n'
  }[name];
};